import { Injectable } from '@angular/core';
import { StateDeclaration, Transition } from '@uirouter/angular';

import { MenuService } from '@tdwb/core';

@Injectable({
  providedIn: 'root'
})
export class LtiRouterMenuService {

  constructor(private menuService: MenuService) {
  }

  checkHideFabMenu(transition: Transition): void {
    const toState: StateDeclaration = transition.to();
    if (toState.data && toState.data.hideFabMenu === true) {
      this.menuService.hideFabMenuForRoute();
    } else {
      this.menuService.showFabMenuForRoute();
    }
  }
}
